export default __webpack_public_path__ + "static/media/shoes7.f1e070c2.jpeg";